import { useEffect, useState } from "react";
import { http } from "@/lib/api";
import { AdminTitle } from "./AdminLayout";

export default function Chats() {
  const [sessions, setSessions] = useState([]);
  const [open, setOpen] = useState(null);
  useEffect(() => { http.get("/admin/chats").then((r) => setSessions(r.data)); }, []);
  return (
    <div data-testid="admin-chats">
      <AdminTitle title="AI-samtaler" sub="Hva kundene spør AI-assistenten om. Bruk dette til å forbedre tjenester, priser og markedsføring." />
      {sessions.length === 0 && <p className="text-sm text-[#5C5A56]">Ingen samtaler ennå.</p>}
      <div className="border-t border-[#E5E0D8]">
        {sessions.map((s) => (
          <div key={s.session_id} className="border-b border-[#E5E0D8]" data-testid={`chat-session-${s.session_id}`}>
            <button onClick={() => setOpen(open === s.session_id ? null : s.session_id)} className="w-full text-left py-4 flex justify-between gap-4 hover:text-[#8C6E48]">
              <span className="text-sm truncate">{s.messages[0]?.content}</span>
              <span className="text-xs text-[#5C5A56] whitespace-nowrap">{new Date(s.last_at).toLocaleString("nb-NO")} · {s.messages.length} meld.</span>
            </button>
            {open === s.session_id && (
              <div className="pb-5 space-y-2">
                {s.messages.map((m) => (
                  <p key={m.id} className={`text-sm p-3 whitespace-pre-wrap ${m.role === "user" ? "bg-[#F0EBE1]" : "border-l-2 border-[#C4A47C] pl-4"}`}>
                    <span className="text-xs uppercase tracking-[0.15em] text-[#8C6E48] block mb-1">{m.role === "user" ? "Kunde" : "AI"}</span>{m.content}
                  </p>
                ))}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
